import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { primeQueryCache } from "../../../utils/primeQueryCache";
import { EventDto } from "../../../models/event/dto/event.dto";
import { GET_EVENT_QUERY_KEY } from "./useGetEvent";

export const GET_EVENTS_QUERY_KEY = (locationId: string, direction: 'past' | 'future') => [locationId, 'events', direction];
export const useGetEvents = (locationId: string, direction: 'past' | 'future') => {
    const client = useApiClient();
    const queryClient = useQueryClient();

    return useQuery({
        queryKey: GET_EVENTS_QUERY_KEY(locationId, direction),
        queryFn: () => client.fetchApi<EventDto[], {}>({ endpoint: `events/list/${direction}?locationId=${locationId}`, method: 'GET' }),
        enabled: !!locationId,
        staleTime: 30_000,
        onSuccess: (data: EventDto[]) => {
            // O(items), not O(items × cache) — see primeQueryCache for the org-switch freeze this loop was part of.
            primeQueryCache(queryClient, (item) => GET_EVENT_QUERY_KEY(item.id), data);
        },
    });
};